export const accentColor = "#2B6FF4";
export const inactiveColor = "#D8E4FA";

export const balancePieChartColors = [
    "#2B6FF4",
    "#76A4FF",
    "#3664BE",
    "#1444A4",
    "#D8E4FA",
    "#A9C0EE",
    "#6E84B0",
    "#002C82",
    "#0040BC",
];

export const monthlyOverviewChartInflowColor = "#2B6FF4";
export const monthlyOverviewChartOutflowColor = "#2B6FF4";

export const last30DaysChartOutflowColor = "#2B6FF4";
export const last30DaysChartInflowColor = "#2B6FF4";
